import React from 'react';
import styles from './Button.module.css';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  onClick,
  children,
  className,
  type = 'button',
}) => {
  const variantMap: Record<string, string> = {
    primary: styles.buttonPrimary,
    secondary: styles.buttonSecondary,
    outlined: styles.buttonOutlined,
    text: styles.buttonText,
  };
  const variantClass = variantMap[variant] || styles.buttonPrimary;
  const sizeClass =
    styles[`button${size.charAt(0).toUpperCase() + size.slice(1)}`];
  const disabledClass = disabled || loading ? styles.buttonDisabled : '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${variantClass} ${sizeClass} ${disabledClass} ${className || ''}`}
    >
      {loading ? 'Loading...' : children}
    </button>
  );
};

export default Button;
